import tokens from './tokens'

const zapInTokens = [tokens.ftm, tokens.dmd, tokens.dai, tokens.usdc, tokens.btc, tokens.eth, tokens.usdt, tokens.mim]

export default zapInTokens
